React = require 'react'
Auth = require 'db/auth'
Dates = require 'lib/dates'
t = require('views/internal/recup-with-helpers')('canonical_comment')
l = require('lib/localize')
Util = require 'lib/util'
moment = require 'moment'
CanonicalCommentInlineReply = require 'views/canonical-detail/canonical-comment-inline-reply'
CanonicalDetailOverflow = require 'views/canonical-detail/canonical-detail-overflow'
trackUe = require 'debug/trackUe'
ReactionPiles = require 'views/reactions/reaction-piles'

{
  Avatar
  DismissIcon
  DetailActions
  DetailContainer
  DetailInfo
  DetailInfoPrimary
  DetailInfoSecondary
  DetailInfoUserName
  CommentText
  CompleteIcon
  ClockIcon
  Header
  IconButton
  SendIcon
  ReactionContainer
} = require 'common/components/canonical-components/canonical-detail'

class CanonicalDetail extends React.Component
  displayName: 'CanonicalDetail'

  render: t.renderable ->
    {
      actionMemberCreator
      board
      canDismiss
      canReply
      cardId
      collapseComment
      commentText
      currentOrgId
      date
      dueDate
      dueSoon
      hasReplied
      idAction
      isActionMemberCreatorDeleted
      isAddMemberToCard
      isEdited
      isReplying
      isWaitingForNetworkResponse
      memberCreator
      onCancelClick
      onChangeDueDateClick
      onChangeReplyMessage
      onCompleteClick
      onDismissClick
      onSaveClick
      onReplyClick
      overflowMenuItems
      reactionList
      replyAction
      replyFailedStatusCode
      replyMessage
      setFocusedCard
      trackOverflowMenuOpens
    } = @props

    t.div =>
      t.div '.canonical-comment', =>
        t.tag DetailContainer, =>
          t.tag CanonicalDetailHeader, {
            actionMemberCreator
            board
            date
            cardId
            dueDate
            dueSoon
            isActionMemberCreatorDeleted
            isAddMemberToCard
            isEdited
            overflowMenuItems
            trackOverflowMenuOpens
          }

          t.tag CanonicalCommentText, {
            cardId
            collapseComment
            commentText
            currentOrgId
            idAction
          }

          t.tag CanonicalReactions, {
            canReply
            idAction
            commentText
            reactionList
          }

          t.tag CanonicalDetailActions, {
            canDismiss
            canReply
            dueSoon
            replyFailedStatusCode
            onChangeDueDateClick
            onCompleteClick
            onDismissClick
            onReplyClick
          }

        t.tag CanonicalCommentReply, {
          isReplying
          isWaitingForNetworkResponse
          hasReplied
          memberCreator
          onCancelClick
          onChangeReplyMessage
          onSaveClick
          replyAction
          replyMessage
          setFocusedCard
          replyFailedStatusCode
          onDismissClick
        }

class CanonicalDetailHeader extends React.Component
  displayName: 'CanonicalDetailHeader'

  render: t.renderable ->
    {
      actionMemberCreator
      board
      cardId
      date
      dueDate
      dueSoon
      isActionMemberCreatorDeleted
      isAddMemberToCard
      isEdited
      overflowMenuItems
      trackOverflowMenuOpens
    } = @props

    name = if !isActionMemberCreatorDeleted
      actionMemberCreator?.get('fullName')
    else
      l(['action', 'deleted-account'])

    t.tag Header, =>
      t.tag CanonicalDetailAvatar, {
        actionMemberCreator
        board
        dueDate
        dueSoon
        isActionMemberCreatorDeleted
      }

      if !dueSoon
        t.tag DetailInfo, ->
          if isAddMemberToCard
            t.tag DetailInfoPrimary, ->
              if Auth.isMe(actionMemberCreator)
                t.format('you-added-yourself-to-card')
              else
                t.format('user-added-you-to-card', { actionMemberCreatorName: name })
          else
            t.tag DetailInfoUserName, ->
              t.text name

          t.tag DetailInfoSecondary, ->
            dateText = if isEdited then "#{moment(date).fromNow()} #{t.l('edited')}" else moment(date).fromNow()
            t.text dateText

      if overflowMenuItems?.length > 0
        t.tag CanonicalDetailOverflow, {
          cardId
          menuItems: overflowMenuItems
          trackOverflowMenuOpens
        }

class CanonicalDetailAvatar extends React.Component
  displayName: 'CanonicalDetailAvatar'

  setDueDateRef: (ref) =>
    @dueDateRef = ref

    if @dueDateRef
      Dates.update(@dueDateRef)

  componentDidUpdate: (prevProps) ->
    if @dueDateRef && prevProps.dueDate != @props.dueDate
      Dates.update(@dueDateRef)

  render: t.renderable ->
    {
      actionMemberCreator
      board
      dueDate
      dueSoon
      isActionMemberCreatorDeleted
    } = @props

    avatarHash = actionMemberCreator?.get('avatarHash')

    if dueSoon
      t.div '.canonical-due-soon-icon-container', =>
        t.div '.text-snippet-icons-container', =>
          t.span { class: 'text-snippet-icon icon-lg icon-clock' }
        t.span '.text-snippet', { ref: @setDueDateRef }, =>
          t.format 'due'
          t.text ' '
          t.span '.date', { key: dueDate, 'data-date': dueDate }

    else if !isActionMemberCreatorDeleted
      t.tag Avatar, {
        key: actionMemberCreator?.id
        deactivated: board.getOrganization()?.getMemberType(actionMemberCreator) == 'deactivated'
        img: avatarHash and [window.avatarDomain, avatarHash, '30.png'].join('/')
        img2x: avatarHash and [window.avatarDomain, avatarHash, '50.png'].join('/')
        initials: actionMemberCreator?.get('initials')
        lightBackground: true
        size: 32
      }

    else
      t.span '.icon-lg.icon-member'

class CanonicalCommentText extends React.Component
  displayName: 'CanonicalCommentText'

  constructor: ->
    @state = {
      containerHeight: 0
      showFullComment: false
    }

    @collapsedCommentHeight = 200
    @onShowFullCommentClick = @onShowFullCommentClick.bind(@)

  componentDidMount: ->
    if @container
      @setState({ containerHeight: @container.clientHeight })

  onShowFullCommentClick: ->
    { cardId, currentOrgId, idAction } = @props

    method = 'by clicking show full comment in highlights feed'
    context = { actionId: idAction, cardId }

    if currentOrgId
      method = 'by clicking show full comment in highlights feed when filtered by team'
      Object.assign(context, { teamId: currentOrgId })

    trackUe('home', 'shows more', 'comment text', '', '', method, context)

    @setState({ showFullComment: true })

  render: t.renderable ->
    { commentText, collapseComment } = @props
    { containerHeight, showFullComment } = @state

    # using actual DOM container height because you can't just count lines of text
    isCollapsed = collapseComment && containerHeight > @collapsedCommentHeight && !showFullComment
    height = if containerHeight && collapseComment then "#{containerHeight}px" else 'auto'

    if commentText
      t.div =>
        t.div '.comment-text-container', {
          # setting height here so we can animate height while still having auto height
          style: { height: if isCollapsed then "#{@collapsedCommentHeight}px" else height }
          ref: (container) => @container = container
        }, =>
          if isCollapsed
            t.div '.hide-comment-overlay'
            t.div '.show-full-comment-container', =>
              t.a '.show-full-comment-button', { onClick: @onShowFullCommentClick }, ->
                t.format 'show-full-comment'

          t.tag CommentText, {
            className: 'markeddown'
            style: { margin: '0 8px -8px' }
          }, =>
            t.raw commentText

    else
      t.div()

class CanonicalReactions extends React.Component
  displayName: 'CanonicalReactions'

  render: t.renderable ->
    {
      canReply
      idAction
      commentText
      reactionList
    } = @props

    if commentText
      t.tag ReactionContainer, =>
        if reactionList?
          t.createElement ReactionPiles, {
            actionId: idAction
            reactionList
            canReact: canReply
            renderReactIconWithBorder: true
            trackingContext: {
              category: 'home'
              actionId: idAction
            }
          }
    else
      t.div()

class CanonicalDetailActions extends React.Component
  displayName: 'CanonicalDetailActions'

  render: t.renderable ->
    {
      canDismiss
      canReply
      replyFailedStatusCode
      dueSoon
      onChangeDueDateClick
      onCompleteClick
      onDismissClick
      onReplyClick
    } = @props

    t.tag DetailActions, =>
      if canReply && onReplyClick && !replyFailedStatusCode
        t.tag IconButton, {
          icon: React.createElement SendIcon
          onClick: onReplyClick
          className: 'canonical-comment-icon-button'
        }, =>
          t.format 'reply'

      if dueSoon && onCompleteClick
        t.tag IconButton, {
          icon: React.createElement CompleteIcon
          onClick: onCompleteClick
          className: 'canonical-comment-icon-button'
        }, =>
          t.format 'complete'

      if canDismiss && onDismissClick
        t.tag IconButton, {
          icon: React.createElement DismissIcon
          onClick: onDismissClick
          className: 'canonical-comment-icon-button'
        }, =>
          t.format 'dismiss'

      if onChangeDueDateClick
        t.tag IconButton, {
          icon: React.createElement ClockIcon
          onClick: onChangeDueDateClick
          className: 'canonical-comment-icon-button'
        }, =>
          t.format 'change-date'


class CanonicalCommentReply extends React.Component
  displayName: 'CanonicalCommentReply'

  render: t.renderable ->
    {
      isReplying
      isWaitingForNetworkResponse
      hasReplied
      memberCreator
      onCancelClick
      onChangeReplyMessage
      onDismissClick
      onSaveClick
      replyAction
      replyMessage
      replyFailedStatusCode
      setFocusedCard
    } = @props

    if isReplying || hasReplied || replyFailedStatusCode
      t.tag CanonicalCommentInlineReply, {
        isReplying
        isWaitingForNetworkResponse
        hasReplied
        memberCreator
        onCancelClick
        onChangeReplyMessage
        onDismissClick
        onSaveClick
        replyAction
        replyMessage
        replyFailedStatusCode
        setFocusedCard
      }
    else
      t.div()

module.exports = {
  CanonicalDetail
  CanonicalDetailHeader
  CanonicalDetailAvatar
  CanonicalCommentText
  CanonicalDetailActions
  CanonicalCommentReply
}



// WEBPACK FOOTER //
// ./app/scripts/views/canonical-detail/canonical-detail-components.coffee